// utils/tableStyles.js

export const tableStyles = {
  "& .MuiTableCell-root": {
    px: 1,       // padding-left/right = theme.spacing(1)
    py: 1,       // padding-top/bottom = theme.spacing(1)
    fontSize: 13
  },
  "& .MuiTableCell-head": {
    fontWeight: 600,
    backgroundColor: "#f1f5f9"
  }
};
